import React, { Component } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import '../../../chat.css';
import ChatQuestionTypeEnum from "../../../config/constants/ChatQuestionTypeEnum";
import Icon from "@material-ui/core/Icon";
import MenuICon from '@material-ui/icons/Menu';
import AttachmentICon from "@material-ui/icons/Attachment";
import {Popover} from "@material-ui/core";
/**
 * Class for the chat message input menu.
 */
class ChatInputMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {isOpen: false,
            chatMenuItemList: [],
            menuIsHovered: false
        }
    }


    handleMenuHover=()=>{
        this.setState({
            menuIsHovered: !this.state.menuIsHovered
        });
    }

    openMenu = () => {
        let chatMenuItemList = [];

        if (this.props.chatConfig && this.props.language) {
            chatMenuItemList = this.props.chatConfig.chatMenuItemList.filter((chatMenuItem) => {
                return chatMenuItem.languageCode === this.props.language.languageCode;
            });
        }

        if (chatMenuItemList.length > 0) {
            chatMenuItemList.sort((a, b) => a.index - b.index);

            this.setState({chatMenuItemList}, () => {
                this.setState({isOpen: true});
            }); 
        }       
    };
    
    closeMenu = () => {
        this.setState({isOpen: false});
    };

    sendIntent = (chatMenuItem) => {
        this.props.sendIntent(chatMenuItem.intentId, ChatQuestionTypeEnum.menuItem,
            chatMenuItem.displayName, null, null, chatMenuItem.id);

        this.closeMenu();
    };

    render() {

        const anchorOrigin = this.props.showAbove ?
            {
                vertical: 'top',
                horizontal: 'right'
            }
            :
            {
                vertical: 'bottom',
                horizontal: 'right'
            }

        const transformOrigin = this.props.showAbove ?
            {
                vertical: 'bottom',
                horizontal: 'right',
            }
            :
            {
                vertical: 'top',
                horizontal: 'right'
            }
     
        return(
            
            <div id={'chat-input-menu-container'}  > 

                <Icon tabIndex={5} id={'chat-input-menu-btn'}  onClick={this.openMenu} ref={(el) => {this.btnEl = el;}}>
                    <MenuICon style={{fill: this.props.chatConfig && this.state.menuIsHovered == true ? this.props.chatConfig.inputButtonsFocusedColor : '#a3a3a8' }}   onMouseEnter={this.handleMenuHover} onMouseLeave={this.handleMenuHover}  />
                </Icon>

                <Menu
                    id="chat-input-menu"
                    anchorEl={this.props.anchorEl}
                    keepMounted
                    open={this.state.isOpen}
                    onClose={this.closeMenu}
                    anchorOrigin={anchorOrigin}
                    transformOrigin={transformOrigin}
                    getContentAnchorEl={null}
                >
                    {this.state.chatMenuItemList.map((chatMenuItem, index) => (
                        <MenuItem onClick={() => {this.sendIntent(chatMenuItem);}} key={index} className={'chat-menu-item'}
                                  style={this.props.chatConfig && this.props.chatConfig.font ?
                                      {font: this.props.chatConfig.font} :
                                      {fontSize: '0.9rem'}}>
                            {chatMenuItem.displayName}
                        </MenuItem>
                    ))}
                </Menu>
            </div>  
           
        );
    }
}

export default ChatInputMenu;
